<!-- 统一用户权限管理 - 资源管理 -->
<template>
    <div>
        <admin-main-header></admin-main-header>

        <div class="admin-main-body">
            <div class="admin-content" :style="{minHeight: adminContentMinHeight + 'px'}">
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 全部资源</span>
                </div>
                <div class="admin-content-main">
                    <div class="el-search-form">
                        <el-form ref="resourceQueryForm" :model="resourceQueryForm">
                            <el-row :gutter="20">
                                <el-col :span="6" :offset="6">
                                    <el-form-item prop="actionType">
                                        <el-checkbox v-model="resourceQueryForm.actionType" true-label="0" false-label="" @change="refreshResourceTree(1000)">仅显示菜单</el-checkbox>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item class="el-align-center">
                                        <el-button @click="resetResourceQueryForm" icon="fas fa-undo">重 置</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                                        <el-button type="primary" @click="refreshResourceTree(1000)" icon="fas fa-sync-alt">刷 新</el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="el-search-list">
                        <el-table id="resourceTreeTable" v-loading="resourceTreeLoading" element-loading-text="拼命加载中..." element-loading-custom-class="el-loading-mask-opacity" :class="{loading: resourceTreeLoading}" :data="resourceTreeList" row-key="resourceId" default-expand-all :indent="32" style="width:100%;" class="el-table-overflow-x-hidden" empty-text="暂无数据">
                            <el-table-column type="selection" width="60"></el-table-column>
                            <el-table-column label="资源名称" prop="resourceName" width="300" align="left">
                                <template slot-scope="scope">
                                    <span :class="['resource-tree-name', {'app-root-resource': scope.row.appRootResource}]"><i :class="['resource-tree-icon', scope.row.resourceIcon]" :style="[formatResourceIconStyle(scope.row.resourceIconStyle)]"></i> {{scope.row.resourceName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="排序号" prop="siblingsIndex" width="100" align="center"></el-table-column>
                            <el-table-column label="功能类型" prop="actionTypeName" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag size="small" :type="getActionTypeTagType(scope.row.actionType)">{{scope.row.actionTypeName}}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="资源URL" prop="resourceUrl">
                                <template slot-scope="scope">
                                    <p v-html="formatResourceUrl(scope.row.resourceUrl)"></p>
                                </template>
                            </el-table-column>
                            <el-table-column label="资源类型" prop="resourceTypeName" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag size="small" :type="getResourceTypeTagType(scope.row.resourceType)">{{scope.row.resourceTypeName}}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="设为首页" prop="indexPage" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag size="small" :type="getIndexPageTagType(scope.row.indexPage)">{{getIndexPageTagName(scope.row.indexPage)}}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="140" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="openResourceViewDialog('view', scope.row)">查看详情</el-button>
                                    <el-dropdown size="small" trigger="click" @command="handleResourceCommand(arguments[0], scope.row)">
                                        <span class="el-dropdown-link">
                                            <i class="el-icon-arrow-down el-icon--right"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="view">查看详情</el-dropdown-item>
                                            <el-dropdown-item command="add">添加资源</el-dropdown-item>
                                            <el-dropdown-item command="edit">修改资源</el-dropdown-item>
                                            <el-dropdown-item command="delete" divided>删除资源</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                    <!-- 添加/修改Dialog -->
                    <el-drawer size="70%" :visible.sync="resourceEditDialogVisible" @closed="closeResourceEditDialog">
                        <span slot="title" class="el-drawer-title"> {{resourceEditDialogTitle}}</span>
                        <div class="el-drawer-content">
                            <el-form class="el-drawer-content-body" ref="resourceEditForm" :model="resourceEditForm" :rules="resourceEditRules" label-width="120px">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="父级资源" prop="parentResourceId">
                                            <el-col :span="12">
                                                <el-input v-model="resourceEditForm.parentResourceName" readonly></el-input>
                                                <input type="hidden" v-model="resourceEditForm.parentResourceId" />
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips"></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="资源名称" prop="resourceName">
                                            <el-col :span="12">
                                                <el-input v-model="resourceEditForm.resourceName" :maxlength="20" :readonly="resourceNameEditable"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">不超过20个字符.</p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="资源代码" prop="resourceCode">
                                            <el-col :span="12">
                                                <el-input v-model="resourceEditForm.resourceCode" :maxlength="50" :readonly="resourceCodeEditable"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">由字母开头5~50字母、数字、下划线组成.</p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="资源功能类型" prop="actionType">
                                            <el-col :span="12">
                                                <el-select v-model="resourceEditForm.actionType" class="el-full-width" :disabled="!actionTypeEditable">
                                                    <el-option label="菜单" :value="0"></el-option>
                                                    <el-option label="按钮" :value="1"></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">“菜单”: 诸如侧边和顶部导航菜单.其余(按钮、链接等)皆称之为"按钮"</p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="排序号" prop="siblingsIndex">
                                            <el-col :span="12">
                                                <el-input v-model="resourceEditForm.siblingsIndex" :maxlength="10"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">兄弟节点间的顺序.</p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="资源URL" prop="resourceUrl">
                                            <el-col :span="12">
                                                <el-input v-model="resourceEditForm.resourceUrl" :maxlength="500"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">例如：http://url.cn/71skk1、/welcome.html等</p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item v-show="resourceEditForm.resourceUrl" label="资源请求方法" prop="httpMethod">
                                            <el-col :span="12">
                                                <el-select v-model="resourceEditForm.httpMethod" clearable class="el-full-width">
                                                    <el-option label="GET" value="GET"></el-option>
                                                    <el-option label="POST" value="POST"></el-option>
                                                    <el-option label="PUT" value="PUT"></el-option>
                                                    <el-option label="DELETE" value="DELETE"></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">资源URL所能允许访问的HTTP请求方法</p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="资源图标类名" prop="resourceIcon">
                                            <el-col :span="12">
                                                <el-input v-model="resourceEditForm.resourceIcon" :maxlength="100"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">例如：'fas fa-home' (来自https://fontawesome.com/icons)</p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="资源图标样式" prop="resourceIconStyle">
                                            <el-col :span="12">
                                                <el-input v-model="resourceEditForm.resourceIconStyle" :maxlength="255"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">例如：'font-size:14px;font-weight:bold;'</p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row v-if="indexPageEditable">
                                    <el-col :span="12">
                                        <el-form-item label="" prop="indexPage">
                                            <el-col :span="12">
                                                <el-checkbox v-model="resourceEditForm.indexPage">是否作为所属应用的首页?</el-checkbox>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips"></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button icon="fas fa-ban" @click="closeResourceEditDialog">取 消</el-button>
                                <el-button type="primary" icon="far fa-save" @click="saveResource" :loading="submiting">确 定</el-button>
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 查看详情Dialog -->
                    <el-drawer size="70%" :visible.sync="resourceViewDialogVisible" @closed="closeResourceViewDialog">
                        <span slot="title" class="el-drawer-title"> 查看资源详情</span>
                        <div class="el-drawer-content">
                            <el-form class="el-drawer-content-body el-form-detail" inline label-position="right" label-width="120px" label-suffix="：">
                                <el-form-item label="资源ID">{{resourceViewForm.resourceId}}</el-form-item>
                                <el-form-item label="资源名称">{{resourceViewForm.resourceName}}</el-form-item>

                                <el-form-item label="资源代码">{{resourceViewForm.resourceCode}}</el-form-item>

                                <el-form-item label="父资源ID">{{resourceViewForm.parentResourceId}}</el-form-item>
                                <el-form-item label="父资源名称">{{resourceViewForm.parentResourceName}}</el-form-item>

                                <el-form-item label="资源功能类型">
                                    <el-tag size="small" :type="getActionTypeTagType(resourceViewForm.actionType)">{{resourceViewForm.actionTypeName}}</el-tag>
                                </el-form-item>
                                <el-form-item label="排序号">{{resourceViewForm.siblingsIndex}}</el-form-item>

                                <el-form-item label="资源URL">
                                    <p v-html="formatResourceUrl(resourceViewForm.resourceUrl)"></p>
                                </el-form-item>
                                <el-form-item label="资源请求方法">{{resourceViewForm.httpMethod}}</el-form-item>

                                <el-form-item label="资源图标类名">{{resourceViewForm.resourceIcon}}</el-form-item>
                                <el-form-item label="资源图标样式">{{resourceViewForm.resourceIconStyle}}</el-form-item>

                                <el-form-item label="资源类型">
                                    <el-tag size="small" :type="getResourceTypeTagType(resourceViewForm.resourceType)">{{resourceViewForm.resourceTypeName}}</el-tag>
                                </el-form-item>
                                <el-form-item label="是否设为首页">
                                    <el-tag size="small" :type="getIndexPageTagType(resourceViewForm.indexPage)">{{getIndexPageTagName(resourceViewForm.indexPage)}}</el-tag>
                                </el-form-item>

                                <el-form-item label="创建时间">{{resourceViewForm.createTime}}</el-form-item>
                                <el-form-item label="修改时间">{{resourceViewForm.updateTime}}</el-form-item>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button icon="fas fa-ban" @click="closeResourceViewDialog">关 闭</el-button>
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { DEFAULT_UPMS_RESOURCE_ICON } from '@/constants.js';
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { isUrl, isRelativeUrl } from '@/utils.js';

const UPMS_RESOURCE_TYPE_SYSTEM = 0;
const UPMS_RESOURCE_ACTION_TYPE_MENU = 0;

const validateResourceUrl = (rule, value, callback) => {
    if (value) {
        if (!(isUrl(value) || isRelativeUrl(value))) {
            return callback(new Error(rule.message));
        }
    }
    callback();
};

export default {
    name: 'UpmsResource',
    data() {
        return {
            submiting: false,
            resourceQueryForm: {
                actionType: null
            },
            resourceTreeLoading: false,
            resourceTreeList: [],
            currentActionType: 'add',
            currentSelectedRow: null,
            resourceEditDialogVisible: false,
            resourceViewDialogVisible: false,
            resourceEditForm: {
                resourceId: '',
                parentResourceId: '',
                parentResourceName: '',
                resourceName: '',
                resourceCode: '',
                actionType: '',
                httpMethod: '',
                resourceUrl: '',
                siblingsIndex: '',
                resourceIcon: DEFAULT_UPMS_RESOURCE_ICON,
                resourceIconStyle: '',
                appRootResource: false,
                indexPage: false
            },
            resourceViewForm: {
                parentResourceId: '',
                parentResourceName: '',
                resourceId: '',
                resourceName: '',
                resourceCode: '',
                actionType: '',
                actionTypeName: '',
                httpMethod: '',
                resourceUrl: '',
                siblingsIndex: '',
                resourceIcon: '',
                resourceIconStyle: '',
                resourceType: '',
                resourceTypeName: '',
                indexPage: false,
                createTime: '',
                updateTime: ''
            },
            resourceEditRules: {
                parentResourceId: [
                    {
                        required: true,
                        message: '未选择父级资源!'
                    }
                ],
                resourceName: [
                    {
                        required: true,
                        message: '请输入资源名称!'
                    },
                    {
                        pattern: /^[a-zA-Z\u00a1-\uffff0-9_]{2,20}$/,
                        message: '资源名称由2~20个中文、字母、数字、下划线组成!'
                    }
                ],
                resourceCode: [
                    {
                        pattern: /^[a-zA-Z]{1}\w{4,49}$/,
                        message: '资源代码由字母开头5~50字母、数字、下划线组成!'
                    }
                ],
                actionType: [
                    {
                        required: true,
                        message: '请选择资源功能类型!'
                    }
                ],
                siblingsIndex: [
                    {
                        required: true,
                        message: '请输资源排序号!'
                    },
                    {
                        pattern: /^\d+$/,
                        message: '排序号必须是整数!'
                    }
                ],
                resourceUrl: [
                    {
                        validator: validateResourceUrl,
                        message: '资源URL不合法!'
                    }
                ],
                resourceIcon: [
                    {
                        pattern: /^([a-zA-Z0-9-_]+(-[a-zA-Z0-9-_]+)?)(\s+[a-zA-Z0-9-_]+(-[a-zA-Z0-9-_]+)?)*$/,
                        message: '资源图标class类不合法!'
                    }
                ],
                resourceIconStyle: [
                    {
                        pattern: /^([a-zA-Z]+(-[a-zA-Z]+)?\s?:\s?[a-zA-Z0-9]{1}[a-zA-Z0-9-('/.,')\s]*)(;\s?[a-zA-Z]+(-[a-zA-Z]+)?\s?:\s?[a-zA-Z0-9]{1}[a-zA-Z0-9-('/.,')\s]*)*;?$/,
                        message: '资源图标样式不合法!'
                    }
                ]
            }
        };
    },
    computed: {
        resourceEditDialogTitle() {
            if (this.currentActionType == 'add') {
                return '添加资源';
            } else if (this.currentActionType == 'edit') {
                return '修改资源';
            } else {
                return '';
            }
        },
        resourceNameEditable() {
            return (
                this.currentActionType == 'edit' &&
                this.resourceEditForm.appRootResource
            );
        },
        resourceCodeEditable() {
            return this.currentActionType == 'edit';
        },
        actionTypeEditable() {
            //当前选中菜单被修改时，如果其存在子菜单，则资源的actionType不能修改
            if (
                this.currentActionType == 'edit' &&
                this.currentSelectedRow.children &&
                this.currentSelectedRow.children.length
            ) {
                return false;
            }
            return true;
        },
        indexPageEditable() {
            if (this.resourceEditForm.actionType == 0) {
                //仅'菜单'类型的资源可以设置为indexPage
                if (
                    this.currentActionType == 'edit' &&
                    this.resourceEditForm.appRootResource
                ) {
                    //应用根资源节点不能设置为indexPage
                    return false;
                }
                return true;
            }
            return false;
        }
    },
    created() {},
    mounted() {
        this.refreshResourceTree(1000);
    },
    methods: {
        getResourceTypeTagType(resourceType) {
            if (resourceType == 0) {
                return 'success';
            } else {
                return 'primary';
            }
        },
        getActionTypeTagType(actionType) {
            return actionType == 0 ? 'primary' : 'success';
        },
        getIndexPageTagType(indexPage) {
            return indexPage ? 'success' : 'primary';
        },
        getIndexPageTagName(indexPage) {
            return indexPage ? '是' : '否';
        },
        /**
         * 格式化资源URL
         */
        formatResourceUrl(resourceUrl) {
            if (resourceUrl) {
                return resourceUrl.replace(/\r{0,}\n/g, '<br/>');
            }
            return '';
        },
        /**
         * 格式化资源ICON的样式
         */
        formatResourceIconStyle(resourceIconStyle) {
            let iconStyle = { fontSize: '14px' };
            if (resourceIconStyle) {
                let styles = resourceIconStyle.split(';');
                styles.forEach(style => {
                    if (style && style.trim()) {
                        let stylePair = style.split(':');
                        if (stylePair && stylePair.length == 2) {
                            iconStyle[
                                stylePair[0].trim()
                            ] = stylePair[1].trim();
                        }
                    }
                });
            }
            return iconStyle;
        },
        refreshResourceTree(loading) {
            let url = PLATFORM_API.of('/api/platform/upms/resource/list');
            if (loading) {
                this.resourceTreeLoading = true;
            }
            setTimeout(() => {
                this.$http
                    .get(url, { params: this.resourceQueryForm })
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.resourceTreeList = result.data;
                        } else {
                            this.resourceTreeList = [];
                        }
                    })
                    .catch(error => {
                        this.resourceTreeList = [];
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.resourceTreeLoading = false;
                        }
                    });
            }, loading);
        },
        resetResourceQueryForm() {
            this.$refs.resourceQueryForm.resetFields();
        },
        handleResourceCommand(cmd, row) {
            if (cmd == 'add') {
                this.openResourceEditDialog(cmd, row);
            } else if (cmd == 'edit') {
                this.openResourceEditDialog(cmd, row);
            } else if (cmd == 'view') {
                this.openResourceViewDialog(cmd, row);
            } else if (cmd == 'delete') {
                this.deleteResource(row);
            }
        },
        openResourceEditDialog(cmd, row) {
            if (
                cmd == 'add' &&
                row.actionType != UPMS_RESOURCE_ACTION_TYPE_MENU
            ) {
                this.$message.error(
                    '只能在资源分类为\'菜单\'的资源下面添加子节点!'
                );
                return;
            }

            if (cmd == 'edit' && row.appRootResource) {
                this.$message.error('应用的根资源节点不允许修改!');
                return;
            }
            this.currentActionType = cmd;
            this.currentSelectedRow = row;
            this.resourceEditDialogVisible = true;
            if (cmd == 'add') {
                Vue.nextTick(() => {
                    this.resourceEditForm.resourceId = '';
                    this.resourceEditForm.parentResourceId = row.resourceId;
                    this.resourceEditForm.parentResourceName = row.resourceName;
                });
            } else if (cmd == 'edit') {
                Vue.nextTick(() => {
                    Object.keys(this.resourceEditForm).forEach(name => {
                        this.resourceEditForm[name] = row[name];
                    });
                });
            }
        },
        closeResourceEditDialog() {
            this.resourceEditDialogVisible = false;
            this.$refs.resourceEditForm.resetFields();
        },
        openResourceViewDialog(cmd, row) {
            this.resourceViewDialogVisible = true;
            Vue.nextTick(() => {
                Object.keys(this.resourceViewForm).forEach(name => {
                    this.resourceViewForm[name] = row[name];
                });
            });
        },
        closeResourceViewDialog() {
            this.resourceViewDialogVisible = false;
            Object.keys(this.resourceViewForm).forEach(name => {
                this.resourceViewForm[name] = '';
            });
        },
        saveResource() {
            let url = '';
            let method = 'post';
            if (this.currentActionType == 'add') {
                url = PLATFORM_API.of('/api/platform/upms/resource/create');
                method = 'post';
            } else if (this.currentActionType == 'edit') {
                url = PLATFORM_API.of('/api/platform/upms/resource/update');
                method = 'put';
            }
            if (url) {
                this.$refs.resourceEditForm.validate(valid => {
                    if (valid && !this.submiting) {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http[method](url, this.resourceEditForm)
                                .then(response => {
                                    let result = response.data;
                                    if (result.success) {
                                        this.closeResourceEditDialog();
                                        this.$message.success(result.message);
                                        this.refreshResourceTree(1000);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1000);
                    } else {
                        return false;
                    }
                });
            }
        },
        deleteResource(row) {
            if (UPMS_RESOURCE_TYPE_SYSTEM == row.resourceType) {
                this.$message.error('系统资源不能删除!');
            } else {
                let url = PLATFORM_API.of(
                    '/api/platform/upms/resource/delete/' + row.resourceId
                );
                this.$confirm('您确定要删除该资源?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http
                        .delete(url)
                        .then(response => {
                            let result = response.data;
                            if (result.success) {
                                this.$message.success(result.message);
                                this.refreshResourceTree(1000);
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch(defaultApiErrorHandler);
                });
            }
        }
    }
};
</script>
<style lang='scss'>
.el-search-form {
    border-bottom: 1px solid #e4e7ed;
}
.resource-tree-icon {
    color: $--color-primary;
}
.resource-tree-name {
    display: inline-block;
    vertical-align: bottom;
    position: relative;
    padding-left: 22px;

    > i {
        position: absolute;
        left: 0;
        top: 1px;
    }
}
.app-root-resource {
    color: $--color-primary;
    font-weight: bold;
}
</style>